import { topicTypes } from '../libs/config'

const getTopicType = (prefixId, contentType) => {
  if (prefixId === 'beantwoord') {
    return topicTypes.ANSWERED
  } else if (prefixId === 'vraag') {
    return topicTypes.QUESTION
  } else if (contentType === 'article') {
    return topicTypes.ARTICLE
  }
  return topicTypes.DISCUSSION
}

export default getTopicType
